import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Col, Nav, Row, Tab,
} from 'react-bootstrap';
import { green } from '../../styles/constants';

const StyledNav = styled(Nav)`
  justify-content: center;
`;

const NavLink = styled(Nav.Link)`
  color: rgba(0,0,0,0.6);
  font-weight: 600;
  z-index: 99;
  
  &.active {
    color: ${green};
    border-bottom: 2px solid ${green};
  }
  
  :hover {
    color: ${green};
    border-bottom: 2px solid ${green};
    opacity: 0.8;
  }
  
  :focus {
    outline: none !important;
    box-shadow: none;
  }
`;

const Stripe = styled.div`
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  background-color: rgba(0,0,0,0.1);
`;

const Tabs = ({ tabs }) => {
  const [key, setKey] = useState(tabs[0].key);

  return (
    <Tab.Container
      activeKey={key}
      onSelect={(k) => setKey(k)}
    >
      <Row>
        <Col>
          <StyledNav>
            {
              tabs.map((tab) => (
                <Nav.Item key={tab.key}>
                  <NavLink eventKey={tab.key}>
                    {tab.name}
                  </NavLink>
                </Nav.Item>
              ))
            }
            <Stripe />
          </StyledNav>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tab.Content>
            {
              tabs.map((tab) => (
                <Tab.Pane
                  key={tab.key}
                  eventKey={tab.key}
                >
                  {tab.pane}
                </Tab.Pane>
              ))
            }
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      pane: PropTypes.node.isRequired,
    }),
  ).isRequired,
};


export default Tabs;
